import { XPage } from "../api/GenericModels";
import { buildMockPromise } from "../api/helpers";
import {
  NameType,
  PersonInfoApi,
  RecurConfigEx,
  RecurInstancePage,
} from "../api/Person";

export const personInfo: PersonInfoApi = {
  birth_date: "1956-06-27",
  addresses: [],
  degrees: [],
  emails: [
    {
      address: "Brigitte.HUEZ@swift.com",
    },
  ],
  identifications: [],
  jobs: [],
  names: [
    {
      first_name: "Brigitte",
      middle_name: " ",
      last_name: "HUEZ",
      name_type: NameType.MAIN,
    },
  ],
  phones: [
    {
      raw_number: "123456789",
    },
  ],
};

export async function getPersonInfoMock(
  person_uuid: string
): Promise<PersonInfoApi> {
  return await buildMockPromise<PersonInfoApi>(personInfo);
}

export async function getRecurInstancePageMock(): Promise<RecurInstancePage> {
  return await buildMockPromise<RecurInstancePage>({
    data: [
      {
        start_date: "2025-09-15T21:53:35",
        request_uuid: undefined,
      },
      {
        start_date: "2025-06-15T21:53:35",
        request_uuid: "80573ba5-8ff2-4ea9-b0d9-4fb3865aab99",
      },
      {
        start_date: "2025-06-11T21:53:35",
        request_uuid: "58d7cd7c-237f-458b-880b-551f6f8c7165",
      },
    ],
    offset: 0,
    page: 1,
    size: 10,
    total: 1,
  });
}

export async function getRecurConfigPageMock(): Promise<XPage<RecurConfigEx>> {
  return await buildMockPromise<XPage<RecurConfigEx>>({
    data: [
      {
        recur_uuid: "fe408d9f-4723-4908-a251-4308e5d1b1f1",
        person_uuid: "38a25b74-1d56-459a-b98e-ff8716692d53",
        company_uuid: "71fcad26-a4ca-4b7a-bc9e-d799ecc9fa8b",
        full_name: "Grant TestFortyTwo",
        custom_id: "",
        check_types: [
          {
            recur_blueprint_uuid: "f65884e1-74df-4ea1-8025-9236ffbfd74e",
            blueprint_uuid: "67b77c23-8f60-4d23-a60f-d104622758a4",
            blueprint_name: "All source - No Web - 3 years",
          },
        ],
        next_run_date: "2025-12-23T13:55:51",
        last_run_date: "2025-07-12T19:23:47",
        last_run_uuid: "dbf21ceb-fb14-4757-ae8a-68ad760ef0fd",
        schedule_type: "interval",
        schedule_value: "3",
        active: true,
        modified_by: "d9cd0b7a-9f27-448b-97e5-18f79a12f858",
        modified_by_name: "grant@fama.io",
        modified_at: "2025-07-02T19:23:54+00:00",
      },
      {
        recur_uuid: "3757dd25-cd84-4e88-9548-a57ad00fd36a",
        person_uuid: "b67f7938-9a31-4735-82ed-b9b2cd1ca4f7",
        company_uuid: "71fcad26-a4ca-4b7a-bc9e-d799ecc9fa8b",
        full_name: "Grant RecurOne",
        custom_id: "",
        check_types: [
          {
            recur_blueprint_uuid: "1a328a9f-1ecf-4dd0-84fb-e0d329ef41ee",
            blueprint_uuid: "67b77c23-8f60-4d23-a60f-d104622758a4",
            blueprint_name: "All source - No Web - 3 years",
          },
        ],
        next_run_date: "2025-10-24T18:05:17",
        last_run_date: "2025-07-11T19:18:59",
        last_run_uuid: "6f8711fe-a2e8-46db-82b6-22143d2cc88f",
        schedule_type: "interval",
        schedule_value: "2",
        active: true,
        modified_by: "d9cd0b7a-9f27-448b-97e5-18f79a12f858",
        modified_by_name: "grant@fama.io",
        modified_at: "2025-07-02T19:19:09+00:00",
      },
    ],
    offset: 1,
    size: 20,
    next: 2,
  });
}
